/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { GlobalPermission } from './GlobalPermission';
const PatchRoleTenantDataParser = /* #__PURE__ */ parsers.object([['permission', GlobalPermission], ['value', codecBoolean]]);
export class PatchRoleTenantData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchRoleTenantDataParser.decode(input).map(res => new PatchRoleTenantData(res));
    }
    static unsafeDecode(input) {
        return PatchRoleTenantData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchRoleTenantDataParser.encode(data);
    }
    static schema() {
        return PatchRoleTenantDataParser.schema();
    }
}
